import React, {useEffect, useRef, useState} from 'react'
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import {
    saveModuleSettings,
    setIsOrdersSettingsFormOpen,
    setIsOrdersSettingsFormSubmitting,
    updateOrdersProcessingRules
} from "../../../redux/orders/reducer";
import {SlidingContainer} from "../../SlidingContainer/SlidingContainer";
import OrderProcessingRules from "./Settings/OrderProcessingRules/OrderProcessingRules";
import Tabs from "../../Tabs2";
import List from "../../Tabs2/components/List";
import Tab from "../../Tabs2/components/Tab";
import Body from 'components/Tabs2/components/Body';
import Panel from "../../Tabs2/components/Panel";
import FulfillmentProcessingRules from "./Settings/FulfillmentProcessingRules/FulfillmentProcessingRules";
import FormOrderModuleSettings from "./Settings/ModuleSettings/FormOrderModuleSettings";
import {Button} from "../../buttons";
import {t} from "i18next";
import store from "../../../redux/store";
import {setTemporaryNotifications} from "../../../redux/notifications/actions";
import {defaultNotificationCreator} from "../../../templates/Notifications";

export interface FilterItem {
    type: string //"channel",
    operator: string //"in",
    values: (string|number)[] //["Ozon", "Wildberries"]
}

export interface Filter {
    [key: string]: FilterItem
}

export interface Warehouse {
    id: string
    name: string
}

const OrdersSettingsFormWrapper = () => {
    const isOrdersSettingsFormOpen = useAppSelector((state) => state.orders.isOrdersSettingsFormOpen);
    const isOrdersSettingsFormSubmitting = useAppSelector((state) => state.orders.isOrdersSettingsFormSubmitting);
    const isOrderModuleSettingsSubmitting = useAppSelector((state) => state.orders.isOrderModuleSettingsSubmitting);
    const isOrdersProcessingRulesSubmitting = useAppSelector((state) => state.orders.isOrdersProcessingRulesSubmitting);
    const [isNeedClearForm, setIsNeedClearForm] = useState<boolean>(false);
    const [isFormOpen, setIsFormOpen] = useState<boolean>(false);
    const [toSubmitProcessingRules, setToSubmitProcessingRules] = useState<boolean>(false);
    const [toSubmitModuleSettingsForm, setToSubmitModuleSettingsForms] = useState<boolean>(false);
    const [isOrderModuleSettingsSubmittingStarted, setIsOrderModuleSettingsSubmittingStarted] = useState<boolean>(false);
    const [isOrdersProcessingRulesSubmittingStarted, setIsOrdersProcessingRulesSubmittingStarted] = useState<boolean>(false);
    const contentRef = useRef<HTMLDivElement>(null);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (isOrderModuleSettingsSubmitting) {
            setIsOrderModuleSettingsSubmittingStarted(true)
        }
        if (isOrdersProcessingRulesSubmitting) {
            setIsOrdersProcessingRulesSubmittingStarted(true)
        }
        if (isOrdersSettingsFormSubmitting && isOrderModuleSettingsSubmittingStarted && isOrdersProcessingRulesSubmittingStarted
            && !isOrderModuleSettingsSubmitting
            && !isOrdersProcessingRulesSubmitting
        ) {
            store.dispatch(setIsOrdersSettingsFormSubmitting(false))
            store.dispatch(setIsOrdersSettingsFormOpen(false))
            store.dispatch(setTemporaryNotifications(
                //@ts-ignore
                defaultNotificationCreator({
                    title: "Настройки сохранены",
                    description: "",
                    iconType: "success"
                })
            ))
            setTimeout(() => {
                window.location.reload()
            }, 2000)
        }
    }, [isOrdersSettingsFormSubmitting, isOrderModuleSettingsSubmitting, isOrdersProcessingRulesSubmitting])

    const closeFeedModalHandler = () => {
        dispatch(setIsOrdersSettingsFormOpen(false))
        setIsNeedClearForm(true)
        setIsFormOpen(false)
    }

    const closeFeedModalOnClickOutsideHandler = () => {
        dispatch(setIsOrdersSettingsFormOpen(false))
        setIsNeedClearForm(true)
        setIsFormOpen(false)
    }

    const submitHandler = () => {
        store.dispatch(setIsOrdersSettingsFormSubmitting(true))
        setToSubmitProcessingRules(true)
        setToSubmitModuleSettingsForms(true)
    }

    return (
        <SlidingContainer
            title={'Настройки заказов'}
            id="orders-settings-form-modal"
            modalOpen={isOrdersSettingsFormOpen}
            toCloseModal={closeFeedModalHandler}
            toCloseModalOnClickOutside={closeFeedModalOnClickOutsideHandler}
            modalContent={contentRef}
        >
            <div style={{'display': 'none'}}>
                isOrderModuleSettingsSubmitting: {JSON.stringify(isOrderModuleSettingsSubmitting)}
                <br/>
                isOrdersProcessingRulesSubmitting: {JSON.stringify(isOrdersProcessingRulesSubmitting)}
                <br/>
                isOrdersSettingsFormSubmitting: {JSON.stringify(isOrdersSettingsFormSubmitting)}
                <br/>
                isOrderModuleSettingsSubmittingStarted: {JSON.stringify(isOrderModuleSettingsSubmittingStarted)}
                <br/>
                isOrdersProcessingRulesSubmittingStarted: {JSON.stringify(isOrdersProcessingRulesSubmittingStarted)}
                <br/>
            </div>

            <div className="mb-4 pt-5 ">
                <div className="mb-4 text-[#1E293B] font-bold text-l w-full text-left">ШК и этикетки</div>
                <FormOrderModuleSettings
                    //@ts-ignore
                    toSubmit={toSubmitModuleSettingsForm}/>
            </div>
            <div className="mb-4 pt-5 ">
                <div className="mb-4 text-[#1E293B] font-bold text-l w-full text-left">Правила автоматической обработки</div>
                <OrderProcessingRules toSubmit={toSubmitProcessingRules}/>
            </div>
            <div className="flex justify-center fixed bottom-0 border-t-[1px] px-3 w-full sm:w-1/3 sm:min-w-[511px] right-0 py-3 bg-white">
                <Button
                    clickHandler={submitHandler}
                    appearance="primary"
                    customClassName="w-full sm:w-5/6 py-2.5"
                    loading={isOrdersSettingsFormSubmitting}
                >
                    {t<string>("Save settings", { ns: "messages" })}
                </Button>
            </div>
        </SlidingContainer>
    )
}

export default OrdersSettingsFormWrapper;